import {Subscription} from 'rxjs';
import {MenuItem} from './menu-item';
import {isNullOrUndefined} from 'util';
import {MatDialog} from '@angular/material/dialog';
import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {PageMapping} from '../utils/PageMapping';
import {UserService} from '../service/user.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ApiServiceService} from '../api-service.service';
import {AnalyticsTracker} from '../utils/AnalyticsTracker';
import {Keys, StorageService} from '../service/storage.service';
import {LoanApplication} from '../model/loan-application.model';
import {LoanApplicationInteractor} from '../interactors/loan-application.interactor';
import {Tracker} from '../utils/tracker';
import { ProductService } from '../service/finzy-flex/product/product.service';
import { ConfigService } from '../service/config.service';
import { LenderApplicationStatus } from '../model/lender.model';
import { MasterProduct } from '../model/finzy-flex/product-list.model';
import { FfEndPoints } from '../views/investors/finzy-flex/ff-endpoints';
import { Validator } from '../utils/Validator';
import { SharedService } from '../service/shared.service';

interface MasterProductWithLink { code: string, name: string, link: string };

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    providers: [ApiServiceService, UserService, StorageService, PageMapping]
})

export class HeaderComponent implements OnInit, OnDestroy {
    public static selectedMenuItem = MenuItem.Borrow;

    @Input()
    secondaryLogoUrl: string;

    name: string;
    response: any;
    loggedIn = false;
    borrowerMenuItem: MenuItem;
    investorMenuItem: MenuItem;
    loginMenuItem = MenuItem.Login;
    shouldShowApplyNowButton = false;
    shouldShowInvestNowButton = false;
    investorMenuItemLink = `/${PageMapping.LENDER_PAGE_PATH_PREFIX}`;
    borrowerMenuItemLink = `/${PageMapping.BORROWER_PAGE_PATH_PREFIX}`;
    isApplicationSubmitted: boolean;
    hasRPC: boolean;
    isLender: boolean;
    isLenderVerified: boolean = false;
    masterProductWithLink: MasterProductWithLink[] = [];
    activeProductName: any;
    maserProductKey: any;
    autoSignIn: boolean;
    private readonly subscriptions: Subscription[] = [];
    private readonly productService: ProductService;
    private readonly configService: ConfigService;

    // check is isFINXLender user
    isFINXLender: boolean = false;

    constructor(private route: ActivatedRoute, private router: Router, private ref: ApiServiceService, private userService: UserService,
                public dialog: MatDialog, private storageService: StorageService, private pageMapping: PageMapping,
                public analyticsTracker: AnalyticsTracker, private loanApplicationInteractor: LoanApplicationInteractor,
                public tracker: Tracker, productService: ProductService, configService: ConfigService, private readonly validator: Validator,
                private readonly sharedService: SharedService
                ) {
                this.productService = productService;
                this.configService = configService;
                this.isFINXLender = this.storageService.getItem(Keys.FINX) === "true" && this.storageService.getItem(Keys.IS_LENDER_CREATED_AFTER_RESTRICTED_DATE) === "true";
    }

    async ngOnInit(): Promise<void> {
        const autoSignInSubscription = this.sharedService.autoSignIn$.subscribe((autoSignIn) => {
            this.autoSignIn = autoSignIn;
        });
        this.subscriptions.push(autoSignInSubscription);
        this.shouldShowApplyNowButton = this.isBorrowerHomePage() || this.isCibilCheckUserDetailsPage();
        this.shouldShowInvestNowButton = this.isLenderHomePage();

        if (!this.isUserLoggedIn()) {
            this.loggedIn = false;

            this.borrowerMenuItem = MenuItem.Borrow;
            this.investorMenuItem = MenuItem.Invest;

            // TODO Extract redirection and menu selection logic into a separate class
            if (this.currentPath() === '/login') {
                HeaderComponent.selectedMenuItem = MenuItem.Login;
            } else if (this.pageMapping.isBorrowerPage(this.currentPath())) {
                HeaderComponent.selectedMenuItem = MenuItem.Borrow;
            } else if (this.pageMapping.isLenderPage(this.currentPath())) {
                HeaderComponent.selectedMenuItem = MenuItem.Invest;
            } else {
                HeaderComponent.selectedMenuItem = undefined;
            }
        } else {
            this.onUserLoggedIn();
            const profileId = this.storageService.getItem(Keys.PROFILE_ID);
            const token = this.storageService.getItem(Keys.TOKEN);

            const [userAndLenderStatus, loanApplication] = await Promise.all([
                this.userService.getUserLenderApplicationStatus(profileId, token),
                this.loanApplicationInteractor.get()
            ]);

            this.borrowerMenuItem = MenuItem.Borrow;
            this.investorMenuItem = MenuItem.Invest;
            this.setHeader(userAndLenderStatus, loanApplication);
            this.isLender = this.isUserALender(userAndLenderStatus.user);
            this.isLenderVerified = this.getLenderStatus(userAndLenderStatus.lenderDetails);
            this.isFlexLenderWithPortfolios(userAndLenderStatus.flexLenderPortfolios);
            if (this.isLenderVerified) {
                this.maserProductKey = this.configService.getMasterProductKey();
                const masterProduct: MasterProduct = await this.productService.getMasterProductsList('lender', this.storageService.getItem('lender_id'));
                this.masterProductWithLink = this.getMasterProductMapper(masterProduct);
                try {
                    this.activeProductName = this.getActiveProductName(masterProduct);
                } catch (e) {
                    this.activeProductName = MenuItem.MyInvestments;
                }
            }
        }

        const subscription = await this.loanApplicationInteractor
            .registerForApplicationRefreshEvent((application) => this.refreshBorrowerHeader(application));
        this.subscriptions.push(subscription);
    }

    logout() {
        this.storageService.clear();
        this.storageService.clearSessionStorage();
        this.loggedIn = false;
        this.navigateTo('/');
    }

    goToHome(event) {
        if (
            this.storageService.getItem(Keys.COMING_FROM_RETAILER_PARTNER_PAYMENT_LINK) &&
            this.storageService.getItem(Keys.RETAILER_PARTNER_LINK_VALIDATED)
            ) {
            this.storageService.clear();
            this.router.navigate(['/borrow']);
            return;
        }

        if (!this.storageService.getItem(Keys.LOAN_ID) && !this.storageService.getItem(Keys.LENDER_ID)) {
            this.navigateTo('/');
        }
    }

    onMenuItemClick(selectedMenuItem: MenuItem): void {
        HeaderComponent.selectedMenuItem = selectedMenuItem;

        switch (selectedMenuItem) {
            case MenuItem.Borrow:
                this.navigateTo('/borrow');
                break;
            case MenuItem.MyLoans:
                this.navigateTo(this.borrowerMenuItemLink);
                break;
            case MenuItem.Invest:
                this.navigateTo('/invest');
                break;
            case MenuItem.MyInvestments:
                this.navigateTo(this.investorMenuItemLink);
            case MenuItem.Login:
                if(this.checkIsComingFromPartnerRetailer()) {
                    this.navigateTo('/');
                } else {
                    this.navigateTo('/login');
                }
        }
    }

    isMenuItemSelected(menuItem: MenuItem): boolean {
        return HeaderComponent.selectedMenuItem === menuItem;
    }

    public onUserLoggedIn(): void {
        this.loggedIn = this.isUserLoggedIn();
        this.name = this.storageService.getItem(Keys.NAME);
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    public checkIsComingFromPartnerRetailer() {
        return Boolean(this.storageService.getItem(Keys.COMING_FROM_RETAILER_PARTNER_PAYMENT_LINK));
    }

    private async refreshBorrowerHeader(loanApplication: LoanApplication) {
        if (this.isUserLoggedIn() && this.pageMapping.isBorrowerPage(this.currentPath()) &&
            this.isUserABorrower(null, loanApplication)) {
            this.borrowerMenuItemLink = '/borrow/dashboard/applications';
            this.borrowerMenuItem = MenuItem.MyLoans;
            HeaderComponent.selectedMenuItem = MenuItem.MyLoans;
        }
    }

    private setHeader(response, loanApplication: LoanApplication) {
        this.hasRPC = !!response.user.onboardedBy;
        const isBorrower = this.isUserABorrower(response.user, loanApplication);
        const isLender = this.isUserALender(response.user);

        if (isBorrower) {
            this.setupHeaderForBorrower();
        }

        if (isLender) {
            this.setupHeaderForLender(response);
        }

        if (this.pageMapping.isBorrowerPage(this.currentPath())) {
            HeaderComponent.selectedMenuItem = isBorrower ? MenuItem.MyLoans : MenuItem.Borrow;
        } else if (this.pageMapping.isLenderPage(this.currentPath())) {
            HeaderComponent.selectedMenuItem = isLender ? MenuItem.MyInvestments : MenuItem.Invest;
        } else {
            HeaderComponent.selectedMenuItem = undefined;
        }
    }

    private setupHeaderForBorrower(): void {
        this.borrowerMenuItemLink = this.pageMapping.whereShouldTheBorrowerBe();
        this.borrowerMenuItem = MenuItem.MyLoans;
    }

    private setupHeaderForLender(response): void {
        let lenderApplicationStatus = response.lenderDetails.lender_status;
        const applicationProcessedStatus = response.lenderDetails.lender_application_status;
        if (lenderApplicationStatus === 'otp_verified' && response.user.email === undefined) {
            lenderApplicationStatus = 'email-verification';
        }
        this.investorMenuItemLink = this.pageMapping.whereShouldTheLenderBe(lenderApplicationStatus, applicationProcessedStatus);
        this.investorMenuItem = MenuItem.MyInvestments;
    }

    private navigateTo(link: string): void {
        this.router.navigate([link]);
    }

    private isUserLoggedIn(): boolean {
        return !isNullOrUndefined(this.storageService.getItem(Keys.TOKEN));
    }

    private isBorrowerHomePage(): boolean {
        return this.router.isActive(PageMapping.BORROWER_PAGE_PATH_PREFIX, true);
    }

    private isCibilCheckUserDetailsPage(): boolean {
        return this.router.isActive(PageMapping.CIBIL_PAGE_PATH_PREFIX, true);
    }

    private isLenderHomePage(): boolean {
        return this.router.isActive(`${PageMapping.LENDER_PAGE_PATH_PREFIX}`, true);
    }

    private isUserABorrower(user: any, loanApplication: LoanApplication): boolean {
        return !!loanApplication || user.loan_details.length > 0;
    }

    private isUserALender(user: any): boolean {
        return user.lender_details.length > 0;
    }

    private currentPath(): string {
        return this.router.routerState.snapshot.url;
    }

    private getLenderStatus(lender): boolean {
        return lender ? lender.lender_application_status === LenderApplicationStatus.INVESTED || lender.lender_application_status === LenderApplicationStatus.VERIFIED : false;
    }

    private getMasterProductMapper(masterProduct: MasterProduct): MasterProductWithLink[] {
        const masterProductWithLink: MasterProductWithLink[] = [];

        masterProduct.data.forEach(product => {
            switch (product.code) {
                case this.maserProductKey.finzyPro:
                    masterProductWithLink.push({ code: product.code, name: product.name, link: '/investordashboard'});
                    break;

                case this.maserProductKey.finxyFlex:
                    if(this.isFINXLender) {
                        masterProductWithLink.push({ code: product.code, name: product.name, link: `/investordashboard` });
                        break;
                    }
                    masterProductWithLink.push({ code: product.code, name: product.name, link: `/${FfEndPoints.FINZY_FLEX}` });
                    break;

                default:
                    masterProductWithLink.push({ code: 'NaN', name: 'NaN', link: 'NaN' });
                    break;
            }
        });
        return masterProductWithLink;
    }

    private getActiveProductName(masterProduct: MasterProduct): string {
        if (this.currentPath().startsWith('/finzy-flex/') || this.currentPath().startsWith('/payment/'))
            return masterProduct.data.find(product => product.code === this.maserProductKey.finxyFlex).name;
        return masterProduct.data.find(product => product.code === this.maserProductKey.finzyPro).name;

    }

    public isFINXUser(productName: string) {
        if(this.isFINXLender && (productName.toLocaleLowerCase() === 'finzyflex')) {
            return true;
        } else {
            false;
        }
    }

    private isFlexLenderWithPortfolios(portfolios: Array<any>){
        if(portfolios && portfolios.length) {
            this.storageService.saveItem('isFlexLenderWithPortfolios', 'true');
        } else {
            this.storageService.saveItem('isFlexLenderWithPortfolios', 'false');
        }
    }

}
